import { tooltipFormatter } from "./commonOptions";
import { MAX_FERMENTING_TEMP } from "@common/constants/chartOptions";

const chartOptions = () => ({
  animation: false,
  textStyle: {
    fontFamily: "Gotham-Medium"
  },
  tooltip: {
    trigger: "axis",
    formatter: tooltipFormatter("fermentation"),
    hideDelay: 5000
  },
  legend: {
    data: ["Temperature", "Predicted"],
    orient: "vertical",
    top: "10%",
    left: "left",
    zlevel: 4
  },
  grid: {
    top: 5,
    left: 30,
    right: 60,
    bottom: 30
  },
  dataZoom: {
    show: true,
    type: "inside",
    filterMode: "none"
  },
  xAxis: [
    {
      max: "dataMax",
      type: "time",
      splitLine: {
        show: false
      },
      axisPointer: {
        value: 0,
        triggerTooltip: false,
        lineStyle: {
          color: "#fdcc00",
          opacity: 1,
          width: 2
        },
        handle: {
          show: true,
          color: "#24262c"
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      scale: true,
      name: "Temp.",
      max: MAX_FERMENTING_TEMP,
      min: 0,
      boundaryGap: [0.2, 0.2]
    },
    {
      type: "value",
      scale: true,
      name: "SG",
      max: 1100,
      min: 900,
      boundaryGap: [0.2, 0.2]
    }
  ],
  series: [
    {
      name: "Actual Temperature",
      showSymbol: false,
      type: "line",
      data: [],
      smooth: true,
      areaStyle: { color: "#fff", opacity: 0.3 },
      lineStyle: { width: 4 },
      color: ["#8dc538"],
      sampling: "average"
    },
    {
      name: "Predicted Temperature",
      connectNulls: true,
      showSymbol: false,
      type: "line",
      data: [],
      smooth: false,
      lineStyle: { width: 4, type: "dotted", opacity: 0.8 },
      color: ["#F2F1EE"],
      markLine: {
        symbol: [false, "circle"],
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "dotted"
        }
      }
    },
    {
      name: "Phases",
      showSymbol: false,
      type: "line",
      data: [],
      markLine: {
        label: {
          show: false
        },
        symbol: false,
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "solid",
          width: 2
        }
      }
    },
    {
      name: "Historic Temperature",
      showSymbol: false,
      type: "line",
      data: [],
      markLine: {
        symbol: false,
        data: [],
        lineStyle: {
          color: "#cfcecd",
          type: "solid",
          width: 2
        }
      },
      smooth: true,
      areaStyle: { opacity: 0.3 },
      lineStyle: { width: 4 },
      color: ["#8dc538"],
      sampling: "average"
    },
    {
      name: "Current Gravity",
      showSymbol: false,
      yAxisIndex: 1,
      type: "line",
      data: [],
      smooth: true,
      areaStyle: { opacity: 0.3 },
      lineStyle: { width: 4 },
      color: ["#fdcc00"],
      sampling: "average"
    }
  ]
});
export default chartOptions;
